import diagnostic from './diagnostics'
import generalInformation from './generalInformation'

const pages = { generalInformation, diagnostic }

export default pages
